import React from 'react'
import { Navigate,Outlet } from 'react-router-dom'
import { USER_DETAILS } from './constants/localstorageKeys'
function PrivateComponent({state}) {
  let auth = localStorage.getItem(USER_DETAILS)
  return auth? <Outlet/> : <Navigate to="/log-in"/>
}

export default PrivateComponent